import {
  checkActionPermission,
  checkPermission,
} from "../../core/routes/RouteValidator";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import $ from "jquery";
import { toast } from "react-hot-toast";
import XConstants from "../../core/config/Constants";
import { useEffect } from "react";
import { PurchaseService } from "./Service";

const ManagePurchase = () => {
  const service = new PurchaseService();
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector((state: any) => state.auth);
  const company = useSelector((state: any) => state.company);

  const getItems = () => {
    try {
      $("#items").DataTable().destroy();
    } catch (e) {
      console.log(e);
    }
    let token = localStorage.getItem("token");
    $("#items").DataTable({
      lengthMenu: [10, 20, 50, 100, 500, 1000],
      pageLength: 100,
      processing: true,
      serverSide: true,
      columnDefs: [
        {
          render: function (data: string, type: any, row: any) {
            return `<p>#${data}</p>`;
          },
          targets: 1,
        },
        {
          render: function (data, type, row) {
            return `
                            <h2 class="table-avatar">
                            <a href="#" class="avatar avatar-md me-2 companies">
                            
                            <img class="avatar-img sales-rep" src="${
                              data[0] != null
                                ? data[0]
                                : `https://ui-avatars.com/api/?background=4F6F52&color=fff&name=${data[1]}&size=40&rounded=true`
                            }" alt="Product Image">
                            </a>
                            <a href="#">${data[1]} <span>${
              data[2]
            }</span></a></h2>
                            `;
          },
          createdCell: (td, cellData, rowData, row, col) => {},
          targets: 2,
        },
        {
          render: function (data: string, type: any, row: any) {
            return `<p>₹${data}</p>`;
          },
          targets: 3,
        },
        {
          render: function (data: any, type: any, row: any) {
            return `<button class="btn btn-primary">Details</button>`;
          },
          createdCell: (
            td: any,
            cellData: any,
            rowData: any,
            row: any,
            col: any
          ) => {
            $(td).click((e: any) => {
              navigate(`${location.pathname}/details/${cellData}`);
            });
          },
          targets: 6,
        },
        {
          render: function (data: any, type: any, row: any) {
            return `<button class="btn btn-danger">Delete</button>`;
          },
          createdCell: (
            td: any,
            cellData: any,
            rowData: any,
            row: any,
            col: any
          ) => {
            $(td).click(async (e: any) => {
              let allowed = checkActionPermission(user, company, "delete");
              if (!allowed) {
                toast.error(
                  "You don't have permission to perform this action",
                  {}
                );
                return;
              }
              const res = await service.updatePurchase(rowData[7], {
                deleted: true,
              });
              if (res) {
                toast.success(`Purchase deleted successfully`, {});
                getItems();
              }
            });
          },
          targets: 7,
        },
      ],
      ajax: {
        url: `${XConstants.baseUrl}/company/purchase/list`,
        type: "POST",
        contentType: "application/json",
        headers: {
          Authorization: token,
        },
        data: function (d: any) {
          return JSON.stringify({
            ...d,
          });
        },
      },
    });
  };

  useEffect(() => {
    getItems();
  }, []);

  const exportCsv = async () => {
    toast.loading("Creating report...");
    const url = await service.exportPurchase({});
    if (url) {
      window.open(url);
    }
  };

  return (
    <>
      <div className="page-header">
        <div className="content-page-header">
          <h5>Purchases</h5>
          <div className="list-btn">
            <ul className="filter-list">
              <li onClick={exportCsv}>
                <div
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Download"
                >
                  <a href="#" className="btn-filters" aria-expanded="false">
                    <span>
                      <i className="fe fe-download" />
                    </span>
                  </a>
                </div>
              </li>
              {checkPermission(user, company, `/purchases/add`) && (
                <li>
                  <Link className="btn btn-primary" to={`/purchases/add`}>
                    <i className="fa fa-plus-circle me-2" aria-hidden="true" />
                    Add Purchase
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="card col-12">
          <div className="card-body w-100">
            <div className="table-responsive w-100">
              <table id="items" className="table datatable  w-100">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Purchase Number</th>
                    <th>Vendor</th>
                    <th>Amount</th>
                    <th>Purchase Mode</th>
                    <th>Date</th>
                    <th>Edit</th>
                    <th>Delete</th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManagePurchase;
